export default "/images/vendor/flag-icons/flags/1x1/ly.svg?d183738e4b1348ff2f12097f6832d942";